import React from 'react';
import { StringColumn, BooleanColumn, CategoricalColumn, CustomColumn } from 'baseui/data-table';
import RiskBadge from '../../components/RiskBadge';

export const COL_NAMES = {
	keyName: 'keyName',
	description: 'description',
	businessCategory: 'businessCategory',
	riskLevel: 'riskLevel',
	dataType: 'dataType',
	serviceCount: 'serviceCount',
	usageCount: 'usageCount',
	isSegmentDependent: 'isSegmentDependent',
	isFrontendExposed: 'isFrontendExposed'
};

export const columnConfigs = [
	StringColumn({
		title: 'Key Name',
		maxWidth: 350,
		mapDataToValue: (data: any) => data[COL_NAMES.keyName]
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.description]
	}),
	CategoricalColumn({
		title: 'Category',
		maxWidth: 180,
		mapDataToValue: (data: any) => data[COL_NAMES.businessCategory]
	}),
	CustomColumn({
		title: 'Risk Level',
		maxWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.riskLevel],
		renderCell: (props: any) => {
			return <RiskBadge level={props.value} />;
		}
	}),
	CategoricalColumn({
		title: 'Data Type',
		maxWidth: 130,
		mapDataToValue: (data: any) => data[COL_NAMES.dataType]
	}),
	StringColumn({
		title: 'Services',
		maxWidth: 120,
		mapDataToValue: (data: any) => String(data[COL_NAMES.serviceCount] ?? 0)
	}),
	StringColumn({
		title: 'Usages',
		maxWidth: 120,
		mapDataToValue: (data: any) => String(data[COL_NAMES.usageCount] ?? 0)
	}),
	BooleanColumn({
		title: 'Segment Dependent',
		maxWidth: 170,
		mapDataToValue: (data: any) => data[COL_NAMES.isSegmentDependent]
	}),
	BooleanColumn({
		title: 'Frontend Exposed',
		maxWidth: 170,
		mapDataToValue: (data: any) => data[COL_NAMES.isFrontendExposed]
	})
];
